import { Loader2, Plus } from 'lucide-react';
import { NavLink, useParams } from 'react-router-dom';
import Table, { createColumnHelper } from '../../Common/components/Table';
import useUserOrg from '../../Authentication/components/hooks/useUserOrg';
import { useDeviceInviteList } from './hooks/useDeviceInviteList';
import DeviceInviteActions from './DeviceInviteActions';
import { Button } from '@/src/shadComponents/ui/button';

const columnHelper = createColumnHelper<DeviceInvite>();

export default function DeviceInvites() {
    const { orgId } = useUserOrg();
    const { groupId } = useParams();
    const { deviceInvites, isLoading } = useDeviceInviteList(
        orgId,
        +(groupId || 0),
    );

    const columnDefinitions = [
        columnHelper.accessor('name', {
            id: 'name',
            header: () => <span>name</span>,
            cell: (info) => <span>{info.getValue()}</span>,
        }),
        columnHelper.display({
            id: 'actions',
            cell: (props: { row: any }) => (
                <DeviceInviteActions
                    row={props.row}
                    orgId={orgId}
                    onDelete={() => null}
                />
            ),
        }),
    ];

    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-12">
                <Loader2 className="size-6 animate-spin text-muted-foreground" />
            </div>
        );
    }

    return (
        <div>
            <div className="flex items-center mx-8 my-4">
                <h2 className="text-lg font-semibold tracking-tight text-foreground">
                    Device Invites
                </h2>
                <div className="flex-1" />
                <NavLink to="/device-management/device-invites/create">
                    <Button>
                        <Plus className="size-4" />
                        Invite Device
                    </Button>
                </NavLink>
            </div>
            {deviceInvites.length === 0 ? (
                <div className="mx-8 text-muted-foreground">
                    There are no open invites for this group
                </div>
            ) : (
                <Table data={deviceInvites} columns={columnDefinitions} />
            )}
        </div>
    );
}
